import * as React from 'react';
import ReactDOM from 'react-dom';
import { ToggleButton } from '~/components/widgets';
import styled from 'styled-components';

class Tools extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
        document.querySelector('body').appendChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}

const Settings = styled.div`
    position: absolute;
    top: 1em;
    right: 1em;
    width: 30%;
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    box-shadow: 0px 0px 25px -5px rgba(0, 0, 0, 0.75);
    background: rgb(255, 255, 255);
    z-index: 1000;
    padding: 1em 0 0 1em;
`;

const List = styled.ul`max-height: 100%;`;

const ListItem = styled.li`
    display: grid;
    grid-template-columns: 70% 10%;
    margin-bottom: 1em;
    align-items: center;
`;

const Heading = styled.h1`font-size: 1.3em;`;

const ToggleContainer = styled.span`display: block;`;

const letterAKeyCode = 65;

export default class extends React.Component {
    state = {
        displaySettings: false
    };

    componentDidMount() {
        document.querySelector('body').addEventListener('keydown', ({ ctrlKey, keyCode }) => {
            if (ctrlKey && keyCode === letterAKeyCode) {
                this.setState(state => ({
                    displaySettings: !state.displaySettings
                }));
            }
        });
    }

    render() {
        const { settings, changeSetting } = this.props;
        const { displaySettings } = this.state;

        return displaySettings ? (
            <Tools>
                <Settings>
                    <Heading>App settings</Heading>
                    <List>
                        {settings.map(([key, value]) => {
                            return (
                                <ListItem key={key}>
                                    <span>{key}</span>
                                    <ToggleContainer>
                                        <ToggleButton isOn={value} onChange={() => changeSetting(key, !value)} />
                                    </ToggleContainer>
                                </ListItem>
                            );
                        })}
                    </List>
                </Settings>
            </Tools>
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/dev-tools/component.js